<template>
 <div class="IG">
   <div v-if="isLoading" class="loader">
    <div class="preloader-wrapper big active">
        <div class="spinner-layer spinner-white-only">
          <div class="circle-clipper left">
            <div class="circle"></div>
          </div><div class="gap-patch">
            <div class="circle"></div>
          </div><div class="circle-clipper right">
            <div class="circle"></div>
          </div>
        </div>
      </div>
   </div>


   <div class="igData" v-if="!isLoading">
    <div class="presentation row" >
      <div class="col s4"><div class="contenitore"><img class="profilephoto" :src="data.profile_pic_url_hd" alt=""></div></div>
      <div class="col s8" style="padding-top: 20px">
          <div class="name"><a :href="'https://www.instagram.com/'+data.username+'/'" target="_blank"><strong class="username" style="color:white">{{data.fullname}}</strong></a></div>
          <div class="foll" style="color:white">
              <b><strong id="media">{{data.media}}</strong></b> POST
              <b><strong class="follower">{{data.follower}}</strong></b> FOLLOWER
              <b><strong class="follows">{{data.follow}}</strong></b> FOLLOWS
          </div>
          <hr class="lineinfo">
          <div class="infoBox">
            <p><strong class="fullname"></strong></p>
          </div>
    
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col l4 m6 s12" v-for="img in imgs" :key="img.id">
          <div class="square">
            <a :href="'https://www.instagram.com/p/'+img.id+'/'" target="_blank">
              <div class="insta" :style="'background-image: url(\''+img.display_url+'\');'"></div>
            </a>
          </div>
        </div>
      </div>
      <div class="moreMedia">
        ..{{data.media - imgs.length}} More  
      </div>
      
    </div>
    
      <div class="seeMore" :onclick="'window.open(\'https://www.instagram.com/'+data.username+'/\')'">See more on Instagram</div>
    </div>
 </div>
</template>


<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

export default {
  name: 'MOAIGPersonal',
  metaInfo() {
      return {
          title: 'MOA - IG Personal',
          meta: [
              {name: 'title', content:'Matteo Ortili Art - Instagram Personal'},
              {name: 'description', content: 'Matteo Ortili\'s personal profile'},
              {property: 'og:title', content: "Matteo Ortili Art - Instagram Personal"},
              {property: 'og:site_name', content: 'MatteOrtiliArt (MOA)'},
              {property: 'og:type', content: 'website'},
              {property: 'og:url', content: 'https://www.matteortili.com/#/instagram/matteortiliart'},
              {property: 'og:description', content: 'Matteo Ortili\'s personal profile'},
              {property: 'og:image:secure_url', itemprop: 'image', content: 'https://www.matteortili.com/imgs/link_img.jpg'},
              
          ]
      }
  },
  data () {
        return {
          isLoading: false,
          data:{},  
          imgs: []
        }
  },
  methods:{
    allData: function(){
      this.isLoading = true;
      console.log(this.isLoading);
      axios.get('https://www.instagram.com/matteortili/?__a=1')
            .then(response => {
              //console.log(response);
              this.data.username = response.data.graphql.user.username;
              this.data.fullname = response.data.graphql.user.full_name;
              this.data.profile_pic_url = response.data.graphql.user.profile_pic_url;
              this.data.profile_pic_url_hd = response.data.graphql.user.profile_pic_url_hd;
              this.data.biography = response.data.graphql.user.biography;
              this.data.follow = response.data.graphql.user.edge_follow.count;
              this.data.follower = response.data.graphql.user.edge_followed_by.count;
              this.data.media = response.data.graphql.user.edge_owner_to_timeline_media.count;
              
              response.data.graphql.user.edge_owner_to_timeline_media.edges.forEach(element => {
                element = element.node;
                //console.log(element)
                var file = {
                  id: element.shortcode,
                  dimensions: element.dimensions,
                  display_url: element.display_url,
                  thumbnail: element.thumbnail_src,
                  likes: element.edge_liked_by.count,
                  caption: element.edge_media_to_caption.edges[0].node.text,

                }
                this.imgs.push(file);
              });
              //console.log(this.data);
              //console.log(this.imgs);
              this.isLoading = false;
              console.log(this.isLoading);
            });
    }
  },
  mounted(){
    console.log(this.isLoading);
    this.allData();
  }

}
</script>


<style scoped>
  @import url('../../assets/styles/instagram/square.css');
  @import url('../../assets/styles/instagram/colori.css');
  @import url('../../assets/styles/instagram/principale.css');
  @import url('../../assets/styles/instagram/instagram.css');

  .seeMore{
    width: max-content;
    padding: 3px 12px 3px 12px;
    border: 1px solid white;
    border-radius: 3px;
    margin: 0 auto;
    text-align: center;
    margin-bottom: 40px;
    text-decoration: none;
    color: white;
    font-family: Roboto;
    text-transform: uppercase;
    font-size: 12pt;
    transition-duration: 500ms;
  }

  .seeMore:hover{
    background-color: white;
    color: black;
    font-weight: bold;
    transition-duration: 500ms;
    cursor: pointer;
  }

  .moreMedia{
    font-family: Roboto;
    font-size: 12pt;
    margin-left: 0.75rem;
    margin-bottom: 20px;
  }

  .row{
    margin-bottom: 0px;
  }

  .IG{
    min-height: 100vh;
  }
  .loader{
    margin-top: 50vh;
    text-align: center;
  }

</style>